import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, ArkUnitOfWork, AuthService, DocumentService, UtilityService } from 'app/core/core.module';
import { Campaign, CommitteeAttachment } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    standalone: true,
    imports: [DxDataGridModule],
    selector: 'app-campaign-overview',
    template: ` <dx-data-grid
        #dataGrid
        keyExpr="id"
        height="100%"
        [dataSource]="campaigns"
        [showBorders]="true"
        [columnAutoWidth]="false"
        [focusedRowEnabled]="false"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellDblClick)="rowDoubleClick($event)"
    >
        <dxi-column dataField="startDate" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
        <dxi-column dataField="name" caption="Name" width="120"></dxi-column>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
        <div *dxTemplate="let data of 'toolbarButtons'">
            <button class="btn btn-sm btn-primary ms-1" (click)="open()">Add</button>
            <button
                class="btn btn-sm btn-success ms-1"
                (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
                [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
            >
                Edit
            </button>
            <button class="btn btn-sm btn-danger ms-2" (click)="delete()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Delete</button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'"></div>
    </dx-data-grid>`,
    styles: ``,
})
export class CampaignOverviewComponent implements OnInit {
    campaigns: Campaign[] = [];
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    router = inject(Router);

    constructor(
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        private modalService: BsModalService,
        public appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.campaigns = await this.uow.campaigns.whereActive();
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            },
        );
    }

    rowDoubleClick(e) {
        this.open(e.data);
    }

    open(campaign?: any) {
        const campaignId = campaign?.id ?? campaign?.id;
        if (!campaignId) this.router.navigate(['/messages/campaigns/new']);
        else this.router.navigate(['/messages/campaigns/', campaignId]);
    }

    async add(selectedRow?: any) {
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                mode: 'text',
                dialogHeader: 'New Campaign',
                dialogValue: '',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                const campaign = this.uow.campaigns.createEntity({
                    name: result.value,
                    created: new Date(),
                    createdBy: this.auth.currentUser.userName,
                    startDate: new Date(),
                });
                await this.uow.commit();
                await this.getData();
            }
            modalRef.hide();
        });
    }

    async delete() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const result = await confirm(`Are you sure you want to delete?`, `GRRAFSCHAP`);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const ids = selectedRows.map((x) => {
            return x.id;
        });
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
